import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';

import styled from 'styled-components';
import { StyledText } from '..';
import { StyledTextVariantsTypeV2 } from '../StyledText';
import {
    GenotypeIcon,
    JournalsIconV2,
    OverviewIcon,
    ProteinShakeBottle2,
    QuestionnaireIcon,
    ReportsIcon,
    ReturnIcon,
    SparklesIcon,
} from 'src/assets/images/custom';

import Routes, { RoutesNames } from 'src/enums/routes';
import { RootState } from 'src/store';
import theme from 'src/styles/theme';
import { translate } from 'src/translations/translations';

const ReturnWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    margin: 24px 0 0 0;
    cursor: pointer;
`;

const Separator = styled.div`
    width: calc(100% + 40px);
    margin: 12px 0 0 -20px;
    border-bottom: 1px solid rgba(59, 135, 140, 0.08);
`;

const Wrapper = styled.div`
    width: calc(100% - 20px);
    display: flex;
    flex-direction: column;
`;

const SessionSidebar = () => {
    const history = useHistory();
    const selectedSession = useSelector((state: RootState) => state.sessionReducer.selectedSession);

    const loadReportsIfAvailable = () => {
        return (
            <NavLink
                to={`/sessions/${selectedSession?.id}/reports`}
                activeStyle={{
                    background: 'rgba(59, 135, 140, 0.24)',
                    borderRadius: '8px',
                }}
                style={{
                    padding: '5% 8px',
                    textDecoration: 'none',
                    marginBottom: '8px',
                    width: '100%',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={ReportsIcon} alt="" height="24px" width="24px" />

                    <StyledText
                        margin={'0 0 0 10%'}
                        text={RoutesNames.REPORTS}
                        variant={StyledTextVariantsTypeV2.NAV_BOLD}
                        colorVariant={theme.colors.v2.light.darkCyan[60]}
                        styles={{ cursor: 'pointer' }}
                    />
                </div>
            </NavLink>
        );
    };

    return (
        <div>
            <ReturnWrapper onClick={() => history.push(Routes.SESSIONS)}>
                <img src={ReturnIcon} alt="back" />
                <StyledText
                    text={translate('return.sessions')}
                    margin={'0 0 0 12px'}
                    variant={StyledTextVariantsTypeV2.NAV_BOLD}
                    styles={{ cursor: 'pointer' }}
                />
            </ReturnWrapper>
            <Separator style={{ marginBottom: '24px' }} />
            <Wrapper>
                <NavLink
                    to={`/sessions/${selectedSession?.id}/`}
                    exact
                    activeStyle={{
                        background: 'rgba(59, 135, 140, 0.24)',
                        borderRadius: '8px',
                    }}
                    style={{
                        padding: '5% 8px',
                        textDecoration: 'none',
                        marginBottom: '8px',
                        width: '100%',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={OverviewIcon} alt="" height="24px" width="24px" />

                        <StyledText
                            margin={'0 0 0 10%'}
                            text={RoutesNames.SESSION_OVERVIEW}
                            variant={StyledTextVariantsTypeV2.NAV_BOLD}
                            colorVariant={theme.colors.v2.light.darkCyan[60]}
                            styles={{ cursor: 'pointer' }}
                        />
                    </div>
                </NavLink>
                <NavLink
                    to={`/sessions/${selectedSession?.id}/results`}
                    activeStyle={{
                        background: 'rgba(59, 135, 140, 0.24)',
                        borderRadius: '8px',
                    }}
                    style={{
                        padding: '5% 8px',
                        textDecoration: 'none',
                        marginBottom: '8px',
                        width: '100%',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={GenotypeIcon} alt="" height="24px" width="24px" />

                        <StyledText
                            margin={'0 0 0 10%'}
                            text={RoutesNames.SESSION_RESULTS}
                            variant={StyledTextVariantsTypeV2.NAV_BOLD}
                            colorVariant={theme.colors.v2.light.darkCyan[60]}
                            styles={{ cursor: 'pointer' }}
                        />
                    </div>
                </NavLink>

                <NavLink
                    to={`/sessions/${selectedSession?.id}/supplement-providers`}
                    activeStyle={{
                        background: 'rgba(59, 135, 140, 0.24)',
                        borderRadius: '8px',
                    }}
                    style={{
                        padding: '5% 8px',
                        textDecoration: 'none',
                        marginBottom: '8px',
                        width: '100%',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={ProteinShakeBottle2} alt="" height="24px" width="24px" />

                        <StyledText
                            margin={'0 0 0 10%'}
                            text={RoutesNames.CUSTOM_SUPPLEMENTS}
                            variant={StyledTextVariantsTypeV2.NAV_BOLD}
                            colorVariant={theme.colors.v2.light.darkCyan[60]}
                            styles={{ cursor: 'pointer' }}
                        />
                    </div>
                </NavLink>

                {loadReportsIfAvailable()}

                <NavLink
                    to={`/sessions/${selectedSession?.id}/questionnaires`}
                    activeStyle={{
                        background: 'rgba(59, 135, 140, 0.24)',
                        borderRadius: '8px',
                    }}
                    style={{
                        padding: '5% 8px',
                        textDecoration: 'none',
                        marginBottom: '8px',
                        width: '100%',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={QuestionnaireIcon} alt="" height="24px" width="24px" />

                        <StyledText
                            margin={'0 0 0 10%'}
                            text={RoutesNames.SESSION_QUESTIONNAIRES}
                            variant={StyledTextVariantsTypeV2.NAV_BOLD}
                            colorVariant={theme.colors.v2.light.darkCyan[60]}
                            styles={{ cursor: 'pointer' }}
                        />
                    </div>
                </NavLink>

                <NavLink
                    to={`/sessions/${selectedSession?.id}/ask-ai`}
                    activeStyle={{
                        background: 'rgba(59, 135, 140, 0.24)',
                        borderRadius: '8px',
                    }}
                    style={{
                        padding: '5% 8px',
                        textDecoration: 'none',
                        marginBottom: '8px',
                        width: '100%',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={SparklesIcon} alt="" height="24px" width="24px" />

                        <StyledText
                            margin={'0 0 0 10%'}
                            text={RoutesNames.ASK_AI}
                            variant={StyledTextVariantsTypeV2.NAV_BOLD}
                            colorVariant={theme.colors.v2.light.darkCyan[60]}
                            styles={{ cursor: 'pointer' }}
                        />
                    </div>
                </NavLink>
            </Wrapper>
            <Separator style={{ marginTop: '24px' }} />

            <Wrapper>
                <StyledText
                    variant={StyledTextVariantsTypeV2.PARAGRAPH_UPPERCASE1}
                    text={translate('notes')}
                    margin={'24px 0 10px 0'}
                    colorVariant={theme.colors.v2.light.blueSapphire[20]}
                />
                <NavLink
                    to={`/sessions/${selectedSession?.id}/notes`}
                    activeStyle={{
                        background: 'rgba(59, 135, 140, 0.24)',
                        borderRadius: '8px',
                    }}
                    style={{
                        padding: '5% 8px',
                        textDecoration: 'none',
                        marginBottom: '8px',
                        width: '100%',
                        margin: '0 0 60px 0',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={JournalsIconV2} alt="" height="24px" width="24px" />

                        <StyledText
                            margin={'0 0 0 10%'}
                            text={RoutesNames.SESSION_JOURNAL}
                            variant={StyledTextVariantsTypeV2.NAV_BOLD}
                            colorVariant={theme.colors.v2.light.darkCyan[60]}
                            styles={{ cursor: 'pointer' }}
                        />
                    </div>
                </NavLink>
            </Wrapper>
            <Separator style={{ marginTop: '24px' }} />
        </div>
    );
};

export default SessionSidebar;
